var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5"},[_c('Packages',{attrs:{"type":"session"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }